import { render, staticRenderFns } from "./ViewFormerMembers.vue?vue&type=template&id=d272cb4a&scoped=true"
import script from "./ViewFormerMembers.vue?vue&type=script&lang=js"
export * from "./ViewFormerMembers.vue?vue&type=script&lang=js"
import style0 from "./ViewFormerMembers.vue?vue&type=style&index=0&id=d272cb4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d272cb4a",
  null
  
)

export default component.exports